import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/* Layout v3 (codevoorstel 26-10): stand van de server (/layout-v3/stand) + licht/donker per apparaat.
   localStorage is alleen een cache zodat de eerste render niet flikkert. */
const SLEUTEL = "bpt_layout_v3_stand";
const THEMA = "bpt_v3_thema";
const LEEG = { flag_aan: false, tester: false, voorkeur: null, actief: false, mag_schakelen: false, crm_actief: false };
const Ctx = createContext({ ...LEEG, thema: "licht", zet: async () => {}, wisselThema: () => {} });
const leesCache = () => { try { return JSON.parse(localStorage.getItem(SLEUTEL) || "null") || LEEG; } catch { return LEEG; } };

export function LayoutV3Provider({ children }) {
  const { user } = useAuth();
  const [stand, setStand] = useState(leesCache);
  const [thema, setThema] = useState(() => localStorage.getItem(THEMA) || "licht");
  const herlaad = useCallback(async () => {
    if (!user) { setStand(LEEG); return; }
    try { const { data } = await api.get("/layout-v3/stand", { bptStil: true }); setStand(data); localStorage.setItem(SLEUTEL, JSON.stringify(data)); }
    catch { /* huidige stand blijft */ }
  }, [user?.id]); // eslint-disable-line
  useEffect(() => { herlaad(); }, [herlaad]);
  const actief = !!user && stand.actief;
  useEffect(() => {
    const h = document.documentElement;
    h.classList.toggle("v3", actief);
    h.classList.toggle("dark", actief && thema === "donker");
    if (actief) h.setAttribute("data-thema", thema); else h.removeAttribute("data-thema");
  }, [actief, thema]);
  const zet = useCallback(async (voorkeur) => {
    const { data } = await api.put("/layout-v3/voorkeur", { voorkeur });
    setStand(data); localStorage.setItem(SLEUTEL, JSON.stringify(data));
    return data;
  }, []);
  const wisselThema = useCallback(() => setThema((t) => { const n = t === "donker" ? "licht" : "donker"; localStorage.setItem(THEMA, n); return n; }), []);
  const waarde = useMemo(() => ({ ...stand, actief, crm_actief: actief && stand.crm_actief, thema, zet, herlaad, wisselThema }), [stand, actief, thema, zet, herlaad, wisselThema]);
  return React.createElement(Ctx.Provider, { value: waarde }, children);
}

export const useLayoutV3 = () => useContext(Ctx);
